import { useTranslation } from 'react-i18next';

import { FormTextField } from '~/components/atoms/form-fields/FormTextField';

import { StyledContainer } from './styled';

export const Coordinates = () => {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <FormTextField name="location.latitude" fullWidth label={t('template5:latitude')} />
      <FormTextField name="location.longitude" fullWidth label={t('template5:longitude')} />
    </StyledContainer>
  );
};
